import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import NiceSelect from './NiceSelect';
import MobileMenu from './MobileMenu';
import LoginForm from './LoginForm';
import { fetchDestinations } from '../../services/api';

function HeaderOne() {
    const location = useLocation();
    const languageOptions = [
        { value: "language", label: "Language" },
        { value: "CNY", label: "CNY" },
        { value: "EUR", label: "EUR" },
        { value: "AUD", label: "AUD" },
    ];
    const [isSticky, setIsSticky] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isLoginFormOpen, setIsLoginFormOpen] = useState(false);
    const [destinations, setDestinations] = useState([]);
    const [showDestinationsDropdown, setShowDestinationsDropdown] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Fetch destinations for dropdown
    useEffect(() => {
        const loadDestinations = async () => {
            try {
                // Fetch all destinations without pagination (or with a large page size)
                const response = await fetchDestinations(1, '', '');
                if (response.success && response.destinations) {
                    setDestinations(response.destinations);
                }
            } catch (error) {
                console.error('Error loading destinations for menu:', error);
            }
        };

        loadDestinations();
    }, []);

    // Check if a route is active
    const isActive = (path) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };

    return (
        <>
            {/*============================== Header Area ==============================*/}
            <header className="th-header header-layout1">
                <div className="header-top">
                    <div className="container th-container">
                        <div className="row justify-content-center justify-content-xl-between align-items-center">
                            <div className="col-auto d-none d-md-block">
                                <div className="header-links">
                                    <ul>
                                        <li className="d-none d-xl-inline-block">
                                            <i className="fa-sharp fa-regular  fa-location-dot" />
                                            <span>45 New Eskaton Road, Austria</span>
                                        </li>
                                        <li className="d-none d-xl-inline-block">
                                            <i className="fa-regular fa-clock" />
                                            <span>Sun to Friday: 8.00 am - 7.00 pm</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="header-right">
                                    <div className="currency-menu">
                                        <NiceSelect options={languageOptions} defaultValue="Language" />
                                    </div>

                                    <div className="header-links">
                                        <ul>
                                            <li className="d-none d-md-inline-block">
                                                <Link to="/faq">FAQ</Link>
                                            </li>
                                            <li className="d-none d-md-inline-block">
                                                <Link to="/contact">Support</Link>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    onClick={() => setIsLoginFormOpen(true)}
                                                >
                                                    Sign In / Register
                                                    <i className="fa-regular fa-user" />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
                    {/* Main Menu Area */}
                    <div className="menu-area">
                        <div className="container th-container">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto">
                                    <div className="header-logo" style={{ scale: '1.4', marginLeft: '80px', width: '150px' }}>
                                        <Link to="/">
                                            <img src="/assets/img/logo.svg" alt="WingsTours" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-auto me-xl-auto">
                                    <nav className="main-menu d-none d-xl-inline-block">
                                        <ul>
                                            <li>
                                                <Link className={isActive('/') ? 'active' : ''} to="/">
                                                    Home
                                                </Link>
                                            </li>
                                            <li
                                                className={`menu-item-has-children ${isActive('/destinations') ? 'active' : ''}`}
                                                onMouseEnter={() => setShowDestinationsDropdown(true)}
                                                onMouseLeave={() => setShowDestinationsDropdown(false)}
                                            >
                                                <Link to="/destinations">Destinations</Link>
                                                <ul className={`sub-menu ${showDestinationsDropdown ? 'show' : ''}`}>
                                                    <li>
                                                        <Link to="/destinations">All Destinations</Link>
                                                    </li>
                                                    {destinations.length > 0 && (
                                                        <>
                                                            <li className="menu-divider" style={{ borderTop: '1px solid #eee', margin: '5px 0' }}></li>
                                                            {destinations.map((destination) => (
                                                                <li key={destination.id}>
                                                                    <Link to={`/destinations?destination=${destination.id}`}>
                                                                        {destination.title}
                                                                    </Link>
                                                                </li>
                                                            ))}
                                                        </>
                                                    )}
                                                </ul>
                                            </li>
                                            <li>
                                                <Link className={isActive('/tours') ? 'active' : ''} to="/tours">Our Tours</Link>
                                            </li>
                                            <li>
                                                <Link className={isActive('/about') ? 'active' : ''} to="/about">About Us</Link>
                                            </li>
                                            <li>
                                                <Link className={isActive('/contact') ? 'active' : ''} to="/contact">Contact us</Link>
                                            </li>
                                            {/* <li>
                                                <Link className={isActive('/gallery') ? 'active' : ''} to="/gallery">Gallery</Link>
                                            </li> */}
                                            <li>
                                                <Link className={isActive('/blogs') ? 'active' : ''} to="/blogs">Blog</Link>
                                            </li>
                                        </ul>
                                    </nav>
                                    <button
                                        type="button"
                                        className="th-menu-toggle d-block d-xl-none"
                                        onClick={() => setIsMobileMenuOpen(true)}
                                    >
                                        <i className="far fa-bars" />
                                    </button>
                                </div>
                                <div className="col-auto d-none d-xl-block">
                                    <div className="header-button">
                                        <Link to="/contact" className="th-btn style3 th-icon">
                                            Book Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="logo-bg bg-mask"
                            style={{
                                WebkitMaskImage: "url(/assets/img/logo_bg_mask.png)",
                                maskImage: "url(/assets/img/logo_bg_mask.png)"
                            }} />
                    </div>
                </div>
            </header>
            <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
            <LoginForm isOpen={isLoginFormOpen} onClose={() => setIsLoginFormOpen(false)} />
        </>

    )
}

export default HeaderOne
